/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Real_Mad_Salmon_FindInputs */

const fr_real_mad_salmon_find = /** @type {(inputs: Real_Mad_Salmon_FindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez sélectionner au moins une personne pour continuer.`)
};

/**

* @param {Real_Mad_Salmon_FindInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const real_mad_salmon_find = /** @type {((inputs?: Real_Mad_Salmon_FindInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Real_Mad_Salmon_FindInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_real_mad_salmon_find(inputs)
});